module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('home-header'), _vm._v(" "), _c('intro'), _vm._v(" "), _c('foobar-search'), _vm._v(" "), _c('foobar-news'), _vm._v(" "), _c('social-links'), _vm._v(" "), _c('home-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3902cb9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 1825
// module chunks = 1